<template>
  <div v-if="changLanguage" Id="Lang">
    <el-select v-model="$store.state.lang" :size="size" placeholder="请选择" @change="changeLang">
      <el-option v-for="item in langs" :key="item.value" :label="item.label" :value="item.value"></el-option>
    </el-select>
  </div>
</template>

<script>
export default {
  name: "changeLang",
  components: {},
  data() {
    return {
      changLanguage: true,//是否開啟多語言【選擇框】
      langs: [{ label: "English", value: "en" }, { label: "繁中", value: "zh-tw" }]// ,{ label: "简中", value: "zh_simplified" },
    };
  },
  props: {
    size: {
      typeof: "string",
      default: "mini"
    }
  },
  mounted() {
    if (!this.changLanguage) {
      this.changeLang('en')
    }
  },
  watch: {
  },
  methods: {
    changeLang(e) {
      let domain = process.env.NODE_ENV == 'development' ? document.location.hostname : process.env.VUE_APP_DOMAIN;
      this.$i18n.locale = e;
      this.$store.state.lang = e;
      this.$cookie.set('CardLang', e, {
        expires: this.$store.state.exdays,
        domain
      });
      if (this.changLanguage) {
        this.$nextTick(() => location.reload());
      }
    },
  },
};
</script>

<style scoped>
#Lang {
  width: 100px;
  line-height: 1.4;
  margin: 0 20px;
}
</style>



// WEBPACK FOOTER //
// src/components/change-lang.vue